import React from 'react';
import Moment from 'react-moment';
import clsx from 'clsx';
import { IconeStatusPedido } from '../../presentations';
import {
    makeStyles,
    withStyles,
    Typography,
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    Paper,
    IconButton
} from '@material-ui/core';
import { InfoOutlined as InfoIcon } from '@material-ui/icons';
import { StatusPedidoEnum } from '../../enums';

const ColorConnector = withStyles(theme => ({
    alternativeLabel: {
        top: 22
    },
    active: {
        '& $line': {
            backgroundColor: theme.palette.secondary.main
        }
    },
    completed: {
        '& $line': {
            backgroundColor: theme.palette.secondary.main
        }
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.action.selected,
        borderRadius: 1,
    }
}))(StepConnector);

const useStylesColorStepIcon = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.action.selected,
        zIndex: 1,
        color: theme.palette.background.paper,
        width: 40,
        height: 40,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    active: {
        backgroundColor: theme.palette.secondary.main
    },
    completed: {
        backgroundColor: theme.palette.secondary.main
    },
}));

function ColorStepIcon(props) {
    const classes = useStylesColorStepIcon();
    const { active, completed } = props;

    return (
        <div className={clsx(classes.root, {
            [classes.active]: active,
            [classes.completed]: completed,
        })}>
            <IconeStatusPedido codigoStatus={props.icon} />
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    titulo: {
        color: theme.palette.primary.main
    },
    data: {
        color: theme.palette.text.disabled
    }
}));

function StepperHorizontalDetalhamentoPedido(
    {
        lista,
        handleClickOpenInfo
    }
) {
    const classes = useStyles();
    const activeStep = lista.map(item => item.statusHabilitado).lastIndexOf(true);

    return (
        <Paper elevation={0} >
            <Stepper alternativeLabel
                activeStep={activeStep}
                connector={<ColorConnector />}>
                {
                    lista.map((item, index) => (
                        <Step key={index}>
                            <StepLabel StepIconComponent={ColorStepIcon}>
                                <Typography variant='h5'
                                    className={clsx({ [classes.titulo]: index <= activeStep })}>
                                    {StatusPedidoEnum.properties[item.codigoStatus].status}
                                </Typography>
                                <Typography variant='caption'
                                    className={clsx({ [classes.data]: index <= activeStep })}>
                                    {item.dataOcorrencia && <Moment utc='0' format="DD/MM/YYYY">{item.dataOcorrencia}</Moment>}
                                </Typography>
                                <Typography>
                                    <IconButton onClick={() => handleClickOpenInfo(item.codigoStatus)}>
                                        <InfoIcon />
                                    </IconButton>
                                </Typography>
                            </StepLabel>
                        </Step>
                    ))
                }
            </Stepper>
        </Paper>
    );
}

export default StepperHorizontalDetalhamentoPedido;